import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";

const initialState = {
    "id" : null,
    "data": {}
}
const SingleChatSelectedMediaData = createSlice({
    name:'singlechatselectedmedia',
    initialState,
    reducers:{
        singleChatSelectedMedia: (_state,payload)=>{
               return {
                "id" : uuidv4(),
                "data":payload.payload
               }
        },resetSingleChatSelectedMedia:(_state,payload)=>{
            return initialState;
        }
    }
});

export default SingleChatSelectedMediaData.reducer
export const singleChatSelectedMedia = SingleChatSelectedMediaData.actions.singleChatSelectedMedia
export const resetSingleChatSelectedMedia = SingleChatSelectedMediaData.actions.resetSingleChatSelectedMedia